module.exports = __webpack_public_path__ + "static/media/CHAP03-CLASSEMENT-WORLD-CUP.ac3068b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/CHAP03-CLASSEMENT-WORLD-CUP.png
// module id = 262
// module chunks = 0